import React from "react";
import { Col, Row } from "react-bootstrap";
import s11 from "../../Assets/Services/print/1-11.png";
import s12 from "../../Assets/Services/print/1-12.png";
import s13 from "../../Assets/Services/print/1-13.png";
import s14 from "../../Assets/Services/print/1-14.png";
import s15 from "../../Assets/Services/print/1-15.png";
import s16 from "../../Assets/Services/print/1-16.png";
import s17 from "../../Assets/Services/print/1-17.png";
import s18 from "../../Assets/Services/print/1-18.png";
import s19 from "../../Assets/Services/print/1-19.png";
import s20 from "../../Assets/Services/print/1-20.png";
import s21 from "../../Assets/Services/print/1-21.png";
import s22 from "../../Assets/Services/print/1-22.png";
import s23 from "../../Assets/Services/print/1-23.png";
import s24 from "../../Assets/Services/print/1-24.png";
import s25 from "../../Assets/Services/print/1-25.png";
import s26 from "../../Assets/Services/print/1-26.png";
import s27 from "../../Assets/Services/print/1-27.png";
import s28 from "../../Assets/Services/print/1-28.png";

function PrintDesign() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s11}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Flyer Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s12}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Post Card Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s13}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Brochure Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s14}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Poster Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s15}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Advertisement Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s16}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Catalogue Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s17}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Envelope Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s18}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Magazine Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s19}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Menu Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s20}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Newspaper Ad Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s21}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Print Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s22}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Sticker Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s23}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Resume Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s24}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Word Template Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s25}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>T-shirt Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s26}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Packaging Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s27}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Mug Design</p>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div>
          <img
            src={s28}
            alt="home pic"
            className="servicelogo"
          />
          <p style={{ fontSize: "12px" }}>Apparel Design</p>
        </div>
      </Col>
    </Row>
  );
}

export default PrintDesign;
